import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-salary-adjustment-day-hour-dialog',
  templateUrl: './salary-adjustment-day-hour-dialog.component.html',
  styleUrls: ['./salary-adjustment-day-hour-dialog.component.less']
})

export class SalaryAdjustmentDayHourDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  nowLoading = false;

  userName = this.data['userName'];

  // 申請内容
  salaryAdjust = {
    yearMonth: this.data['yearMonth'],
    staffDailyCleaning: this.data['staffDailyCleaning'],
    staff: this.data['staff'],

    statusWorkDays: '0',
    statusPhDays: '0',
    statusHours: '0',

    workDays: null,
    phDays: null,
    hours: null,

    updateUser: localStorage.getItem("userName")
  }

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SalaryAdjustmentDayHourDialogComponent>,) { }

  ngOnInit() {
  }

  /**
   * キャンセルボタン
   */
  cancel() {
    this.dialogRef.close();
  }

  /**
   * 申請ボタン
   */
  save() {

    // 変更あり
    if (this.salaryAdjust.statusWorkDays == '1') {
      if (this.salaryAdjust.workDays == null) {
        alert('勤務日数を入力してください。')
        return
      }
      if (this.salaryAdjust.workDays == this.data['changeWorkDays']) {
        alert('勤務日数の変更が、以前変更した値と変わりません。変更なしにチェックをつけてください。')
        return
      }
    }
    if (this.salaryAdjust.statusPhDays == '1') {
      if (this.salaryAdjust.phDays == null) {
        alert('有休日数を入力してください。')
        return
      }
      if (this.salaryAdjust.phDays == this.data['changePhDays']) {
        alert('有休日数の変更が、以前変更した値と変わりません。変更なしにチェックをつけてください。')
        return
      }
    }
    if (this.salaryAdjust.statusHours == '1') {
      if (this.salaryAdjust.hours == null) {
        alert('時間（勤務+有休）を入力してください。')
        return
      }
      if (this.salaryAdjust.hours == this.data['changeHours']) {
        alert('時間の変更が、以前変更した値と変わりません。変更なしにチェックをつけてください。')
        return
      }
    }

    // 変更なし
    if (this.salaryAdjust.statusWorkDays == '0' && this.salaryAdjust.statusPhDays == '0' && this.salaryAdjust.statusHours == '0') {
        alert('変更するものがないため保存できません。')
        return
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.nowLoading = true

    this.http.post(
        API_BASE_URL + '/api/v1/salary/saveAdjustDays?userId=' + localStorage.getItem("uid"),
          this.salaryAdjust,
          httpOptions
      ).subscribe(res => {
        this.dialogRef.close(true);
      },error => {
        alert("エラーが発生したため保存できませんでした。再度登録をお願いします。");
        console.log(error)
        this.nowLoading = false;
      });
  }
}


